import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { cfAPI } from "../api";
import { createFormData } from "../utils/onCreateFormData";
import { createProgressHandler } from "../utils/createProgressHandler";

// Action Types
const EVENT_REQUEST = "EVENT_REQUEST";
const EVENT_ERROR = "EVENT_ERROR";
const EVENTS_FETCH = "EVENTS_FETCH";
const EVENT_FETCH = "EVENT_FETCH";
const EVENT_CREATE = "EVENT_CREATE";
const EVENT_EDIT = "EVENT_EDIT";
const EVENT_DELETE = "EVENT_DELETE";

// Download Action Types for events
const EVENT_DOWNLOAD_START = "EVENT_DOWNLOAD_START";
const EVENT_DOWNLOAD_UPDATE = "EVENT_DOWNLOAD_UPDATE";
const EVENT_DOWNLOAD_FINISH = "EVENT_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/events";

// Reusable action types object for consistency
const actionTypes = {
  fetches: {
    request: EVENT_REQUEST,
    success: EVENTS_FETCH,
    error: EVENT_ERROR,
  },
  fetch: { request: EVENT_REQUEST, success: EVENT_FETCH, error: EVENT_ERROR },
  create: { request: EVENT_REQUEST, success: EVENT_CREATE, error: EVENT_ERROR },
  update: { request: EVENT_REQUEST, success: EVENT_EDIT, error: EVENT_ERROR },
  delete: { request: EVENT_REQUEST, success: EVENT_DELETE, error: EVENT_ERROR },
  download: {
    request: EVENT_REQUEST,
    start: EVENT_DOWNLOAD_START,
    update: EVENT_DOWNLOAD_UPDATE,
    finish: EVENT_DOWNLOAD_FINISH,
    success: EVENTS_FETCH,
    error: EVENT_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  events: [],
  event: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// Actions using the new handlers
export const FetchEvents = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const FetchEvent = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetch,
    null // No toast for a fetch
  );
};

export const CreateEvent = (values) => async (dispatch) => {
  console.log("Creating event with values:", values);
  console.log("FormData contents:", createFormData(values));

  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, createFormData(values)),
    actionTypes.create,
    "Event Created"
  );
};

export const UpdateEvent = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, createFormData(values)),
    actionTypes.update,
    "Event Updated"
  );
};

export const DeleteEvent = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "Event Deleted"
  );
};

// Reducer with toasts removed and state logic updated
export const EventsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EVENT_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case EVENT_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case EVENT_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };
    case EVENT_REQUEST:
      return { ...state, loading: true };
    case EVENTS_FETCH:
      return { ...state, loading: false, error: "", events: action.payload };
    case EVENT_FETCH:
      return { ...state, loading: false, error: "", event: action.payload };
    case EVENT_CREATE:
      return {
        ...state,
        loading: false,
        success: true,
        events: [...state.events, action.payload],
      };
    case EVENT_EDIT:
      const updatedList = state.events.map((event) =>
        event.id === action.payload.id ? action.payload : event
      );
      return {
        ...state,
        loading: false,
        success: true,
        event: action.payload,
        events: updatedList,
      };
    case EVENT_DELETE:
      const newList = state.events.filter((s) => s.id !== action.payload.id);
      return { ...state, loading: false, success: true, events: newList };
    case EVENT_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
